import { ArrowRight, RefreshCw } from "lucide-react";
import { ComponentProps } from "react";
import * as SelectPrimitive from "@radix-ui/react-select";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import t from "@/lang/lang";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import {
  ListRequest,
  useRelationshipsRelationshipListQuery,
} from "@/services/backend/relationships/api/service";
import { BranchName } from "@/services/backend/company/components/branch-name";
import { ServiceObjectName } from "@/services/backend/customers/components/service-object-name";
import { CompanyName } from "@/services/backend/company/components/company-name";
import { CustomerName } from "@/services/backend/customers/components/customer-name";

export function RelationshipSelect({
  listRequest,
  ...props
}: ComponentProps<typeof SelectPrimitive.Root> & {
  listRequest: ListRequest;
}) {
  const { data, isLoading, error } =
    useRelationshipsRelationshipListQuery(listRequest);

  return (
    <Select {...props}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder={t("Beziehung auswählen")} />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {isLoading && (
            <SelectItem value="loading" disabled>
              <RefreshCw className="size-4" />
              <span>{t("Lade Beziehungen")}</span>
            </SelectItem>
          )}
          {error && (
            <SelectItem value="error" disabled>
              <RTKQueryErrorAlert error={error} />
            </SelectItem>
          )}
          {data?.relationships.length === 0 && (
            <SelectItem value="error" disabled>
              <span>{t("Keine Beziehungen")}</span>
            </SelectItem>
          )}
          {data?.relationships.map((relationship) => (
            <SelectItem value={relationship.id} key={relationship.id}>
              <CompanyName companyId={relationship.companyId} short />
              <BranchName branchId={relationship.branchId} />
              <ArrowRight />
              <CustomerName customerId={relationship.customerId} />
              <ServiceObjectName id={relationship.serviceObjectId} />
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
